import type { ProductMM } from '@/entities';
import type {
  ICartAPIService,
  ICartCRUDItem,
  ICartFullEntityResponse,
  ICartLiteEntityResponse,
  IProductEntityCart,
} from '../../models';

import { CartResponse } from './CartResponse';

export abstract class _CartStore<
  TCartAPIService extends ICartAPIService,
  TCartResponse extends ICartLiteEntityResponse | ICartFullEntityResponse,
> {
  public readonly products = ref<ProductMM<IProductEntityCart>[]>([]);
  public readonly qnty = ref<number>(0);
  public readonly updatedAt = ref<number>(0);

  public cartResponse = new CartResponse<TCartResponse>();

  protected APIService?: TCartAPIService;

  public injectAPIService(apiService: TCartAPIService) {
    this.APIService = apiService;
  }

  public abstract fetchCart(): Promise<any>;

  public abstract addProductToCart(product: IProductEntityCart, qnty: number): Promise<any>;

  public abstract patchCart(data: ICartCRUDItem[]): Promise<any>;

  public async syncCart() {
    return this.APIService?.syncCart();
  }

  public getProductBySkuId(skuId?: string) {
    return this.products.value.find((it) => it.product.skuId === skuId);
  }

  public reset() {
    this.cartResponse.reset();
    this.products.value = [];
    this.updatedAt.value = 0;
    this.qnty.value = 0;
  }

  protected abstract handleResponse(cartResp: TCartResponse): void;

  protected isResponseOutdated(response: TCartResponse): boolean {
    if (!response.updatedAt) return true;
    if (!this.cartResponse.response?.updatedAt) return false;
    return this.cartResponse.response.updatedAt >= response.updatedAt;
  }
}
